import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import CustomLoader from "../../Components/custom/CustomLoader";
import moment from "moment";
import { useFetch } from "../../hooks/queries";
import { IoChevronBackCircleOutline } from "react-icons/io5";

const Assignments = () => {
  const { id } = useParams();
  const [perPage, setPerPage] = useState(100);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const { state } = useLocation();

  const { data, isPending, isLoading, isFetching } = useFetch({
    queryKey: ["coursesAssignments", id, page, perPage],
    url: `${process.env.REACT_APP_API_URL}Courses/GetAssignments?CourseId=${id}&PageNumber=${page}&PageSize=${perPage}`,
    method: "PATCH",
  });

  const assignments = data?.data || [];
  const totalRows = data?.totalCount || 0;

  const isAssignmentsLoading = isPending || isLoading || isFetching;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const columns = [
    {
      name: "Assignment ID",
      selector: (row) => row.id,
      sortable: true,
      width: "150px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Due Date",
      selector: (row) =>
        row.dueAt == null ? "N/A" : moment(row.dueAt).format("YYYY-MM-DD"),
      sortable: true,
    },
    {
      name: "Points",
      selector: (row) => row.pointsPossible,
      sortable: true,
      width: "120px",
    },
    {
      name: "Grading Type",
      selector: (row) => row.gradingType,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => (row.published ? "Published" : row.workflowState),
      sortable: true,
      width: "140px",
    },
  ];

  return (
    <div className="content">
      <div className="left-side">
        <div className="container-fluid mt-30">
          <div className="table-title-container">
            <IoChevronBackCircleOutline
              size={25}
              color="#287a9f"
              className="back-btn"
              onClick={() => navigate(-1)}
            />
            <p className="title-table">
              {state?.courseName} - {state?.operatorName}
            </p>
          </div>
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Assignments</h3>
            </div>
            <div className="card-body p-0">
              <DataTable
                data={assignments}
                columns={columns}
                pagination
                paginationServer={true}
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[100, 200, 300, 500]}
                progressPending={isAssignmentsLoading}
                progressComponent={<CustomLoader />}
                fixedHeader
                fixedHeaderScrollHeight={"75vh"}
                defaultSortFieldId={1}
                onRowClicked={(e) =>
                  navigate(`/Courses/grades/${e.id}`, {
                    state: {
                      assignmentName: e.name,
                    },
                  })
                }
                pointerOnHover
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assignments;
